import o from "./CustomPageTitle.vue2.js";
import t from "../../../../_virtual/_plugin-vue_export-helper.js";
const m = /* @__PURE__ */ t(o, [["__scopeId", "data-v-eba700ca"]]);
export {
  m as default
};
